import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from '../../utils/baseQueryFn';

function flattenStaffProfile(item) {
    if (!item || !item.user_profile) return item;
    return {
        ...item,
        ...item.user_profile,
        user_profile: undefined,
    };
}

const consultantAPI = createApi({
    reducerPath: "consultantAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllConsultants: builder.mutation({
            query: ({ page, size, key }) => {
                let apiUrl = `staff?page=${page}&size=${size}`;

                if (key) {
                    apiUrl += `&key=${key}`;
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => {
                if (response?.content) {
                    return {
                        ...response,
                        content: response.content.map(flattenStaffProfile),
                    };
                }
                return response;
            },
            providesTags: ["consultant"],
        }),
        getConsultantByID: builder.mutation({
            query: (id) => ({
                url: `staff/${id}`,
                method: "GET",
            }),
            transformResponse: (response) => flattenStaffProfile(response),
        }),
        registerConsultant: builder.mutation({
            query: (body) => ({
                url: `staff`,
                method: "POST",
                body
            }),
            invalidatesTags: ["consultant"],
        }),
        updateConsultantById: builder.mutation({
            query: ({ id, body }) => ({
                url: `staff/admin/${id}`,
                method: "PUT",
                body
            }),
            invalidatesTags: ["consultant"],
        }),
        deleteConsultant: builder.mutation({
            query: (id) => ({
                url: `staff/admin/${id}`,
                method: "DELETE",
                body:{}
            }),
            invalidatesTags: ["consultant"],
        }),
    }),
});

export const { 
    useGetAllConsultantsMutation,
    useGetConsultantByIDMutation,
    useRegisterConsultantMutation,
    useUpdateConsultantByIdMutation,
    useDeleteConsultantMutation
} = consultantAPI;
export default consultantAPI;